import React, {Fragment, useState} from 'react';
import Error from './Error'
import PropTypes from 'prop-types';


const Pregunta = ({setPresupuesto, setRestante, setMostrarPregunta}) => {

    const [cantidad, setCantidad] = useState(0)
    const [error, setError] = useState(false)

    const definirPresupuesto = e=> {
        setCantidad( parseInt(e.target.value));
    }

    const agregarPresupuesto = e=> {
        e.preventDefault();
        //Validate
        if(cantidad<1 || isNaN(cantidad)){
            setError(true);
            return;
        }

        setError(false);
        setPresupuesto(cantidad);
        setRestante(cantidad);
        setMostrarPregunta(false);
    }

    return ( 
        <Fragment>
            <h2>Insert your budget</h2>
            { error ? <Error mensaje="wrong value"/> : null}
            <form
                onSubmit={agregarPresupuesto}
            >
                <input
                    type="number"
                    className="u-full-width"
                    placeholder="insert your budget"
                    onChange={definirPresupuesto}
                    />
                <button
                    type="submmit"
                    className="button-primary u-full-width"
                    >Process</button>
            </form>
        </Fragment>

     );
}
 
Pregunta.propTypes = {
    setPresupuesto: PropTypes.func.isRequired,
    setRestante: PropTypes.func.isRequired,
    setMostrarPregunta: PropTypes.func.isRequired
}

export default Pregunta;